import useTemplateDataFromIds from "../moduleLinkHub/useTemplateDataFromIds";

export default useTemplateDataFromIds;
